export const ERROR = {
  AUTHORIZATION_REQUIRED: 'AUTHORIZATION_REQUIRED',
  NotFoundError: 'NotFoundError',
  INACTIVE_PAPER: 'INACTIVE_PAPER',
  REGISTRATION: 'REGISTRATION',
  EXCEEDED: 'EXCEEDED',
};

export const ERROR_VARIABLE = {
  AUTHORIZATION_REQUIRED: {
    EN: 'You need to log in',
    TH: 'คุณต้องเข้าสู่ระบบ',
  },
  NotFoundError: {
    EN: 'Record not found, Please contact your system administrator',
    TH: 'ไม่พบข้อมูล, กรุณาติดต่อผู้ดูแลระบบ',
  },
  INACTIVE_PAPER: {
    EN: 'This paper has already been done, Please contact your system administrator',
    TH: 'ข้อสอบนี้ได้เสร็จสิ้นไปแล้ว, กรุณาติดต่อผู้ดูแลระบบ',
  },
  REGISTRATION: {
    EN: 'Please register the course before taking its exam',
    TH: 'กรุณาลงทะเบียนเรียนก่อนเข้าสอบ',
  },
  EXCEEDED: {
    EN: 'Unable to perform the exam. This exam has already exceeded the limitation.',
    TH: 'ไม่สามารถทำแบบทดสอบซ้ำได้ เนื่องจากเคยทำแบบทดสอบไปแล้ว',
  },
};

export const RESPONSIVE_BREAKPOINT = {
  TABLET: 992,
  MOBILE: 768,
};

export const PROVIDER_NAME = {
  ONDEMAND: 'ondemand',
  LEARNED: 'learned',
  IGNITE: 'ignite',
};

export const PROVIDER_NAME_SHORT_HAND = {
  ONDEMAND: 'OD',
  LEARNED: 'LE',
};

// STOP using this constant use data in config per provider instead
export const OUTSIDE_LINK_URL = {
  CLEAR: 'http://ibooking.ondemand.in.th/one/authentication/authentication/signin',
  ONLINE_SOLUTION: 'http://ibooking.ondemand.in.th/one/authentication/authentication/signin',
  FEEDBACK: 'https://form.jotform.me/91341255302446',
};

export const COURSE_TYPES = {
  PACK: 'PACK',
  SINGLE: 'SINGLE',
};

export const COURSE_MODE = {
  TUNGKAI: 'TUNGKAI',
};

export const EXAM_MODE = {
  RANDOM: 'RANDOM',
  FIXED: 'FIXED',
};

export const QUIZ_VARIANT = {
  QUIZ_V2: 'quizv2',
  QUIZ_FEED: 'quiz-feed',
};
